import React from "react";

/*
    Left Icon
    props:
        - title: string, override the default title 'small-dropdown-arrow'
        - color: string, override the default color '#00549A' (bell blue)
*/

const SmallDropdownIcon = (props) => (
    <svg className={props.className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <title>{props.title || "small-dropdown-arrow"}</title>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.37263 10.8345L12.8726 5.83448C13.1622 5.51272 12.9339 5 12.501 5H3.50098C3.0681 5 2.83975 5.51272 3.12933 5.83448L7.62933 10.8345C7.82796 11.0552 8.17401 11.0552 8.37263 10.8345Z"
            fill={props.color || "#00549A"}
        />
    </svg>
);

export default SmallDropdownIcon;
